import PropTypes from 'prop-types';

// Card component wrapper
export const Card = ({ children, className }) => {
  return (
    <div className={`bg-white shadow-md rounded-2xl p-4 ${className}`}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

// CardHeader component
export const CardHeader = ({ children, className }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
};

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

// CardTitle component
export const CardTitle = ({ children, className }) => {
  return (
    <h2 className={`text-xl font-bold text-gray-800 ${className}`}>{children}</h2>
  );
};

CardTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

// CardContent component
export const CardContent = ({ children, className }) => {
  return (
    <div className={`text-gray-600 ${className}`}>
      {children}
    </div>
  );
};

CardContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
